<script>
/**
 * ****************************************************************************
 * @description     :   Multi Select Component
 * @created at      :   2024/06/22
 * @created by      :   ANS794 – longvv@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
import { Core as YubinBangoCore } from 'yubinbango-core2';
/**
 * Import template
 */
import template from './template.html';
import axios from 'axios';
import helpers from '@/utils/helpers';

/**
 * Define content of Zip Code component
 */
var AnsZipCode = {
    template: template,
    components: { YubinBangoCore },
    props: {
        id: String,
        label: String,
        name: String,
        itemClass: String,
        labelClass: String,
        inputClass: String,
        value: [String, Number],
        modelValue: [String, Number],
        emptyText: String,
        isRequired: {
            type: Boolean,
            default: false
        },
        isDisabled: Boolean,
        isReadonly: Boolean,
        isMobile: {
            type: Boolean,
            default: false
        },
        isFromSearch: {
            type: Boolean,
            default: false
        },
        removeEmptyOption: {
            type: Boolean,
            default: false
        },
        options: Array,
        onChange: Function,
        onFocus: Function,
        onBlur: Function,
        keyValueOptions: {
            type: Array,
            default: ['code', 'name']
        },
        positionReferValue: {
            type: Number,
            default: 0
        },
        isTab: {
            type: Boolean,
            default: false
        },
        isHorizontal: {
            type: Boolean,
            default: false
        },
        widthLabel: {
            type: String,
            default: 'width-110-px'
        },
        errors: {
            type: Array
        },
        isDisableIME: {
            type: Boolean,
            default: false
        },
        showButton: {
            type: Boolean,
            default: true
        },
        isAutocomplete: {
            type: Boolean,
            default: false
        }
    },
    mounted() {
        this.initData();
    },
    emits: ['update:modelValue', 'referAddressByZipCode', 'referGeoCode'],
    computed: {
        vewValue() {
            return this.formatPostalCode(this.modelValue ? this.modelValue : this.value);
        },
        enableButton() {
            if (this.postalCode) {
                return this.postalCode.length == 7 || this.postalCode.length == 8;
            }
            return false;
        }
    },
    data() {
        return {
            postalCode: this.value ? this.value : '',
            geocoder: { lat: 0, lng: 0 },
            modeDisabled: false
        };
    },
    created() {
        this.modeDisabled = helpers.checkAuthorityMode(this.$route.name);
    },
    watch: {
        postalCode(val) {
            if (val) {
                const formattedVal = this.formatPostalCode(val);
                this.$emit('update:modelValue', formattedVal);
            } else {
                this.$emit('update:modelValue', '');
            }
        },
        modelValue(val) {
            this.postalCode = this.formatPostalCode(val);
        }
    },
    methods: {
        initData() {
            if (this.modelValue) {
                this.postalCode = this.formatPostalCode(this.modelValue);
            }
        },
        validateZipCd(e) {
            let reg1 = /^[0-9]{3}-[0-9]{4}$/;
            let reg2 = /^[0-9]{3}[0-9]{4}$/;
            let zip_cd = e.target.value;
            if ((zip_cd.match(reg1) || zip_cd.match(reg2)) && zip_cd != '') {
                this.postalCode = zip_cd;
                if (zip_cd.length == 7) {
                    zip_cd = zip_cd.substring(0, 3) + '-' + zip_cd.substring(3);
                    e.target.value = zip_cd;
                }
                if (!this.showButton) {
                    this.referAddress();
                    this.referGeoCode();
                }
            } else {
                e.target.value = '';
                this.postalCode = '';
                this.$emit('referAddressByZipCode', '');
            }
        },
        formatPostalCode(value) {
            if (value && !value.includes('-')) {
                const sanitizedValue = value.replace(/-/g, '');
                if (sanitizedValue.length === 7) {
                    return sanitizedValue.substring(0, 3) + '-' + sanitizedValue.substring(3);
                }
            }
            return value;
        },
        referAddress() {
            new YubinBangoCore(this.postalCode, (addr) => {
                let valueRefer = addr.region + addr.locality + addr.street;
                this.$emit('referAddressByZipCode', valueRefer);
            });
        },
        referGeoCode() {
            const zipCode = this.postalCode.replace(/-/g, '');
            axios
                .get('https://maps.googleapis.com/maps/api/geocode/json?address=' + zipCode + '&key=' + process.env.VUE_APP_GOOGLE_API_KEY)
                .then((response) => {
                    if (response.data.results[0]) {
                        this.geocoder.lat = response.data.results[0].geometry.location.lat;
                        this.geocoder.lng = response.data.results[0].geometry.location.lng;
                    } else {
                        console.log('not valid zipcode');
                    }
                })
                .then(() => {
                    this.$emit('referGeoCode', {
                        ...this.geocoder
                    });
                })
                .catch((error) => console.log('error referGeoCode', error));
        },
        inputKeydown(e) {
            return this.inputOnlyNumber(e);
        },
        inputOnlyNumber(e) {
            if (
                !(
                    (e.keyCode > 47 && e.keyCode < 58) ||
                    (e.keyCode > 95 && e.keyCode < 106) ||
                    e.keyCode == 116 ||
                    e.keyCode == 46 ||
                    e.keyCode == 37 ||
                    e.keyCode == 39 ||
                    e.keyCode == 35 ||
                    e.keyCode == 36 ||
                    e.keyCode == 8 ||
                    e.keyCode == 9 ||
                    e.ctrlKey ||
                    e.keyCode == 229 ||
                    e.keyCode == 13 ||
                    e.keyCode == 189 ||
                    e.keyCode == 109
                )
            ) {
                event.preventDefault();
                return false;
            }
            return true;
        }
    }
};
export default AnsZipCode;
</script>
